import React from 'react';

export const SeoContext = React.createContext();
